<template>
  <div id="app" />
</template>
<script>
import '@/assets/font/iconfont.css'
import Vue from 'vue'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Svg from '@/components/home/Svg'
Vue.component('v-icon', Svg)
Vue.use(ElementUi)
export default {
  name: 'Head',
  components: {
  }
}
</script>
<!--
<style>
  body {
    min-width: 1280px;
    font-family:"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu;
  }

  body, ul {
    margin: 0;
    padding: 0;
    font-size: 12px;
  }
  
</style>
-->
<style lang="scss" rel="stylesheet/scss">
// rem 单位换算：定为 75px 只是方便运算，750px-75px、640-64px、1080px-108px，如此类推
$vw_fontsize: 75; // iPhone 6尺寸的根元素大小基准值
@function rem($px) {
     @return ($px / $vw_fontsize ) * 1rem;
}

// 根元素大小使用 vw 单位
$vw_design: 750;
html {
    font-size: ($vw_fontsize / ($vw_design / 2)) * 100vw; 
    // 同时，通过Media Queries 限制根元素最大最小值
    @media screen and (max-width: 320px) {
        font-size: 64px;
    }
    @media screen and (min-width: 540px) {
        font-size: 108px;
    }
}

// body 也增加最大最小宽度限制，避免默认100%宽度的 block 元素跟随 body 而过大过小
body {
    max-width: 540px;
    min-width: 320px;
    margin: 0 auto;
    padding: 0;
    background: #e8e8ed;
    font-size: 14px;
    font-family: -apple-system,Helvetica,sans-serif;
    line-height: 1.5;
    color: #666;
}
p
{
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.container
{
  background: #fff;
  // padding: 0.1rem;
  margin-top: 8vh;
  //显示固定底部需要启用下面两行样式
  // margin-bottom: 6vh;
  // min-height:86vh;
  min-height: 92vh;
}
</style>
